<script setup>
import { debounce } from "lodash";
import { ref, onMounted, nextTick, watch } from "vue";
const BASE_URL = ref(process.env.BASE_URL);
const bannerHeight = ref();
const screenWidth = ref();
const h = ref();
const emit = defineEmits(["changeHeight"]);
const props = defineProps({
  info: {
    type: Object,
    default: () => {},
  },
});

onMounted(() => {
  window.addEventListener("resize", () => {
    let he = document.documentElement.clientHeight;
    h.value = he;
  });
});
watch(
  () => h.value,
  val => {
    nextTick(() => {
      let div1 = document.getElementById("banner_id");
      bannerHeight.value = window
        .getComputedStyle(div1)
        .getPropertyValue("height");
      emit("changeHeight", bannerHeight.value);
    });
  },
  {
    immediate: true,
  }
);
</script>
<script>
export default {
  name: "banner",
};
</script>
<template>
  <div
    id="banner_id"
    class="banner"
    :style="{
      'background-image': `url(${BASE_URL}static/img/banner/${props.info.img}.png)`,
    }"
    data-aos="zoom-out-down"
    data-aos-anchor="top-center"
  >
    <div class="banner-text" data-aos="zoom-in" data-aos-delay="200">
      <div>
        <h3>{{ props.info.title }}</h3>
        <h6>{{ props.info.en }}</h6>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.banner {
  padding: 0;
  height: calc(100vh - 15.5rem);
  color: #fff;
  // padding: 0 10vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  color: #333;
  .banner-text {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    margin: auto 10rem;
  }
  h3 {
    width: 70vw;
    // font-size: 4vw;
  }
  h6 {
    width: 70vw;
    font-size:3rem;
    padding: 0;
    margin: 0;
    font-size:3rem;
    font-weight: bold;
    opacity: 0.5;
    color: #0670b9;
    // position: absolute;
    // top: 0.5vw;
  }
}
</style>
